Service = App.loadClass 'core::Angular/Service'

class exports.NavigationService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    loadSafeLink: (search, append) =>
        if not append
            start = 0

        return @http.post 'grower::home/load-safe-link',
            search: search
            start: start
